<template>
  <section class="q-mt-xl">
    <div class="row col-12 items-center cracha-header">
      <span class="text-h6 text-brand-5"
        >Retirada nos Tablets por ID (Crachá)</span
      >
      <q-select
        class="q-ml-sm col-2 cracha-select"
        outlined
        dense
        v-model="codigo"
        :options="options"
        label="Suas identificações"
        :option-label="
          (opt) => (Object(opt) === opt && 'card_id' in opt ? opt.card_id : '')
        "
      />
    </div>
    <section
      class="row col-12 text-brand-5 text-weight-bold q-gutter-sm q-mt-lg cracha-inputs-container"
    >
      <div class="col-md-2 col-xs-12 cracha-input-item">
        <div>Numero</div>
        <q-input dense outlined v-model="userData.codigoUser" />
      </div>
      <div class="col-md-2 col-xs-12 cracha-input-item">
        <div>Nova Senha</div>
        <q-input
          dense
          outlined
          maxlength="4"
          v-model="userData.senha"
          :type="isPwd ? 'password' : 'text'"
        >
          <template v-slot:append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>
      <div class="col-md-2 col-xs-12 cracha-input-item">
        <div>Confirme a Senha</div>
        <q-input
          dense
          outlined
          maxlength="4"
          v-model="userData.novaSenha"
          :type="isPwd ? 'password' : 'text'"
        />
      </div>
    </section>
    <div class="row q-gutter-x-sm q-mt-md">
      <q-btn
        icon="add"
        no-caps
        color="positive"
        label="Criar"
        @click="criarCodigo"
      />
      <q-btn
        no-caps
        icon="sync"
        color="secondary"
        label="Atualizar"
        @click="atualizarCodigo"
      />
      <q-btn
        icon="delete"
        no-caps
        color="red"
        label="Deletar"
        @click="deletarCodigo"
      />
    </div>
  </section>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
export default {
  props: {
    id: {
      type: String,
    },
  },
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const senha = ref("");
    const repertirSenha = ref("");
    const codigo = ref("");
    const options = ref([]);

    const userData = ref({
      codigoUser: "",
      senha: "",
      novaSenha: "",
    });

    const getCards = async () => {
      try {
        let response = await store.dispatch("user/getCards", {
          id: props.id,
        });

        options.value = response.data.results.data;
      } catch (error) {
        $q.notify({
          message: "Erro a o procurar codigo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCards);

    const criarCodigo = async () => {
      if (
        userData.value.senha != userData.value.novaSenha ||
        userData.value.codigoUser == ""
      ) {
        $q.notify({
          message: "As senhas não coincidem ou o numero esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("user/setCards", {
          user_id: props.id,
          card_id: userData.value.codigoUser,
          password: userData.value.senha,
        });
        $q.notify({
          message: "Codigo criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        userData.value.codigoUser = "";
        userData.value.senha = "";
        userData.value.novaSenha = "";
        codigo.value = "";
        /* for (const dados in userData.value) {
          userData.value[dados] = "";
        }*/

        getCards();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar cracha, ou ele ja existe",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizarCodigo = async () => {
      if (
        userData.value.senha != userData.value.novaSenha ||
        userData.value.codigoUser == ""
      ) {
        $q.notify({
          message: "As senhas não coincidem ou o numero esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("user/atualizarCards", {
          user_id: props.id,
          card_index: codigo.value.id,
          card_id: userData.value.codigoUser,
          password: userData.value.senha,
        });

        $q.notify({
          message: "Codigo atualizado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        for (const dados in userData.value) {
          userData.value[dados] = "";
        }
        getCards();
      } catch (error) {
        $q.notify({
          message: "Erro a o atualizar codigo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletarCodigo = async () => {
      try {
        await store.dispatch("user/deletarCards", {
          card_index: codigo.value.id,
        });

        $q.notify({
          message: "Codigo deletador com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        userData.value.codigoUser = "";
        userData.value.senha = "";
        userData.value.novaSenha = "";
        codigo.value = "";
        getCards();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar codigo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => codigo.value,
      () => {
        userData.value.codigoUser = codigo.value.card_id;
      }
    );

    return {
      senha,
      repertirSenha,
      codigo,
      options,
      userData,
      criarCodigo,
      atualizarCodigo,
      deletarCodigo,
      isPwd: ref(true),
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .cracha-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    margin-bottom: 16px;
  }

  .cracha-select {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 12px !important;
  }

  .cracha-inputs-container {
    flex-direction: column !important;
    gap: 0 !important;
  }

  .cracha-input-item {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin: 0 0 16px 0 !important;
  }

  .cracha-input-item:last-child {
    margin: 0 0 16px 0 !important;
  }

  .cracha-input-item .q-field {
    width: 100% !important;
  }
}

@media (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .cracha-header {
    margin-bottom: 12px !important;
  }

  .cracha-select {
    margin-top: 8px !important;
  }

  .cracha-input-item {
    margin: 0 0 12px 0 !important;
  }

  .cracha-input-item:last-child {
    margin: 0 0 12px 0 !important;
  }
}
</style>
